import * as React from 'react';
import FormInputWrapper from 'modules/FormInputWrapper';
import { OptionTypeBase } from 'react-select';
// import NumberFormat from 'react-number-format';
// import { ColorInput, ImageUpload, Checkbox, FormInputWrapper } from '@modules/modules';
import { Select, LazySelect, Checkbox } from 'modules';
import TimeSelect from 'modules/TimeSelect';
import classNames from 'classnames';
import { FormikErrors } from 'formik';

type SelectOption = OptionTypeBase;

export type FormInputType =
  | 'decimal'
  | 'number'
  | 'money'
  | 'text'
  | 'textarea'
  | 'select'
  | 'lazy-select'
  | 'checkbox'
  | 'image'
  | 'password'
  | 'color'
  | 'time'
  | 'date';

export interface FormInputProps {
  ref?: any;
  name: string;
  label?: React.ReactElement | string;
  type?: FormInputType;
  required?: boolean;
  autoFocus?: boolean;
  autoComplete?: string;
  readOnly?: boolean;
  disabled?: boolean;
  className?: string;
  value?: string | string[] | number | null;
  // language?: GQL.ILanguage | null;
  checked?: boolean;
  description?: string;
  minLength?: number;
  min?: number;
  max?: number;
  rows?: number;
  width?: string | number;
  maxWidth?: string | number;
  pattern?: string;
  multiple?: boolean;
  options?: Array<SelectOption>;
  placeholder?: string;
  error?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
  style?: any;
  onChange?: (e: any) => void;
  onLoadOptions?: (inputValue: any, callback: any) => void;
  onInputChange?: (value: string) => void;
  onKeyPress?: (e: React.KeyboardEvent) => void;
  onLeave?: () => void;
}

const FormInput = React.forwardRef<HTMLElement, FormInputProps>(
  (
    {
      name,
      autoFocus,
      autoComplete,
      className,
      checked,
      multiple,
      options,
      style,
      onLoadOptions,
      onInputChange,
      onKeyPress,
      onLeave,
      ...props
    }: FormInputProps,
    ref,
  ) => {
    // default props
    props = {
      ...{
        type: 'text',
        rows: 5,
      },
      ...props,
    };

    const onChange = (e: any) => {
      let targetValue = e.target.value;
      if (type === 'number') {
        targetValue = parseInt(targetValue, 10);
      }

      const newValue = targetValue;

      if (props.onChange) {
        props.onChange({
          target: {
            name: e.target.name,
            value: newValue,
          },
        });
      }
    };

    // const onPriceChange = (e: any) => {
    //   if (props.onChange) {
    //     props.onChange({
    //       target: {
    //         name: props.name,
    //         value: parseFloat(e.target.value.toString().replace(' ', '')),
    //       }
    //     });
    //   }
    // };

    const onChangeSelect = (selected: any) => {
      if (props.onChange) {
        const newValue =
          multiple === true ? selected.map((v: SelectOption) => v.value) : selected ? selected.value : null;
        props.onChange({
          target: {
            name,
            value: newValue,
          },
        });
      }
    };

    // const selectOptions = () => {
    //   if (props.options) {
    //     return Object.keys(props.options).map((key: string | number) => {
    //       return {
    //         value: key,
    //         label: (props.options && props.options[key]
    //           ? props.options[key]
    //           : key)
    //       };
    //     });
    //   }

    //   return [];
    // };

    // const getSelectOption = (v: string) => {
    //   return selectOptions().find((o) => o.value === v);
    // };

    const selectedOption = () => {
      if (!options || !value) {
        return null;
      }
      if (multiple) {
        return options.filter((o: SelectOption) => (value as string[]).some((v: string) => v === o.value));
      } else {
        return options.find((o: SelectOption) => o.value === value);
      }
    };

    const inputID = 'id_' + name;

    let type = props.type;
    let pattern = props.pattern;
    if (!pattern) {
      switch (props.type) {
        case 'decimal':
          pattern = '\\d{0,8}(\\,\\d{1,4})?';
          type = 'text';
          break;
        default:
          break;
      }
    }

    const value = props.value ? props.value : '';

    return (
      <>
        <FormInputWrapper
          // type={type}
          label={type === 'checkbox' ? undefined : props.label}
          required={props.required}
          disabled={props.disabled}
          description={props.description}
          // controlInputStyle={{ maxWidth: props.maxWidth }}
          error={props.error}
        >
          {type === 'checkbox' && (
            <Checkbox
              id={inputID}
              className={className}
              name={name}
              checked={!!checked}
              label={props.label}
              required={props.required}
              readOnly={props.readOnly}
              disabled={props.disabled}
              onChange={onChange}
            />
          )}

          {type === 'textarea' && (
            <textarea
              ref={ref as any}
              id={inputID}
              name={name}
              className={classNames(['form-control', className])}
              autoFocus={autoFocus || false}
              readOnly={props.readOnly}
              disabled={props.disabled}
              value={value || ''}
              rows={props.rows}
              placeholder={props.placeholder}
              style={style}
              onChange={onChange}
              onBlur={onLeave}
            />
          )}

          {type === 'select' && (
            <Select
              ref={ref}
              name={name}
              // className={className}
              value={selectedOption()}
              isMulti={multiple}
              readOnly={props.readOnly}
              isDisabled={props.disabled}
              // styles={customStyles}
              placeholder={'Vyberte ...'}
              onChange={onChangeSelect}
              onBlur={onLeave}
              style={style}
              options={options}
            />
          )}

          {type === 'lazy-select' && (
            <LazySelect
              ref={ref}
              name={name}
              value={selectedOption()}
              isMulti={multiple}
              readOnly={props.readOnly}
              isDisabled={props.disabled}
              placeholder={'Vyberte ...'}
              options={options}
              onChange={onChangeSelect}
              cacheOptions={true}
              loadOptions={onLoadOptions}
              defaultOptions={true}
              onInputChange={onInputChange}
            />
          )}

          {type === 'time' && (
            <TimeSelect
              // className={className}
              name={name}
              value={value as string}
              // isMulti={multiple}
              // styles={customStyles}
              onChange={onChange}
            />
          )}

          {/* <Select
          id={inputID}
          name={name}
          className="select"
          classNamePrefix="select"
          value={getSelectOption(props.value !== undefined ? props.value : '')}
          autoFocus={autoFocus || false}
          readOnly={props.readOnly}
          isDisabled={props.disabled}
          // isMulti={props.multiple}
          onChange={onSelectChange}
          placeholder={props.placeholder || 'Vyberte ... '}
          isClearable={props.required !== true}
          options={selectOptions()}
        /> */}

          {/* {type === 'money' &&
        <NumberFormat
          thousandSeparator={` `}
          decimalSeparator={`,`}
          decimalScale={2}
          id={inputID}
          type="text"
          name={name}
          value={value}
          className="form-control"
          required={props.required}
          disabled={props.disabled}
          onChange={onPriceChange}
          style={{ float: 'left', width: '100px', marginRight: '5px' }}
        />} */}

          {/* {type === 'image' &&
        <ImageUpload
          name={name}
          value={props.value ? props.value.toString() : undefined}
          disabled={props.disabled}
          onChange={onChange}
        />} */}

          {/* {type === 'color' &&
        <ColorInput
          name={name}
          value={props.value}
          disabled={props.disabled}
          onChange={onChange}
        />} */}

          {type !== 'money' &&
            type !== 'checkbox' &&
            type !== 'textarea' &&
            type !== 'select' &&
            type !== 'lazy-select' &&
            type !== 'image' &&
            type !== 'color' &&
            type !== 'time' && (
              <>
                <input
                  ref={ref as any}
                  id={inputID}
                  type={type}
                  name={name}
                  value={value || ''}
                  className={classNames(['form-control', className])}
                  minLength={props.minLength}
                  min={props.min}
                  max={props.max}
                  // required={props.required}
                  autoComplete={autoComplete}
                  autoFocus={autoFocus || false}
                  readOnly={props.readOnly}
                  disabled={props.disabled}
                  pattern={pattern}
                  placeholder={props.placeholder}
                  onChange={onChange}
                  onKeyPress={onKeyPress}
                  onBlur={onLeave}
                  style={{
                    width: props.width,
                    maxWidth: props.maxWidth,
                    ...style,
                  }}
                />
              </>
            )}
        </FormInputWrapper>
      </>
    );
  },
);

export default FormInput;
